module.exports = __webpack_public_path__ + "static/img/wood41.14e97eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood41.jpg
// module id = riZs
// module chunks = 0